import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../config/config.service';
import { Parametro } from '../../../types/Parametro.type';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getList(){
    return this.httpClient.get<Parametro[]>(`${this.configService.getApiUrlIntegrador()}/parametros/`)
  }
  put(parametro: Parametro){
    return this.httpClient.put(`${this.configService.getApiUrlIntegrador()}/parametros/`, parametro)
  }

  
}
